import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { creatorGaps } from '../../data/content';
export function Creator() {
  return <section className="bg-steel-100 py-12 sm:py-16" aria-labelledby="creator-title" data-id="element-112" data-mp="1ja6zf9gjf1or">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-113" data-mp="1j842e5gyw8aj">
        <p className="text-center font-display text-sm font-bold uppercase tracking-[0.18em] text-gold-600" data-id="element-114" data-mp="1oa33f8p8it4b">
          About the creator
        </p>
        <h2 id="creator-title" className="mt-1 text-center font-display text-3xl font-extrabold uppercase leading-none text-ink-900 sm:text-5xl" data-id="element-115" data-mp="2g0haom2qt770">
          Pedro Talavera
        </h2>

        <div className="mt-7 grid items-start gap-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-8" data-id="element-116" data-mp="26zj8m9bv79r2">
          <img src="https://cdn.magicpatterns.com/uploads/75FWGCQzCPXADn92BRJFYK/PEDRO_TALAVERA_TECNICO.png" alt="Pedro Talavera, creator of the Premium Technician Kit, in his appliance repair workshop" className="w-full rounded-2xl border border-ink-900/10 object-cover shadow-sm" width={1256} height={1256} loading="lazy" data-id="element-117" data-mp="qlt0mrhmk1c5" />

          <div data-id="element-118" data-mp="37eucm13b60ft">
            <p className="text-[15px] leading-relaxed text-ink-700 sm:text-base" data-id="element-119" data-mp="37fch1l04jkyt">
              Pedro Talavera created the Premium Technician Kit™ around a simple
              observation:
            </p>
            <p className="mt-3 rounded-xl border-l-4 border-gold-500 bg-white px-4 py-3 text-[15px] font-semibold leading-relaxed text-ink-900 sm:text-base" data-id="element-120" data-mp="3gdxxnam1cpwy">
              Great technicians shouldn’t have to look unprofessional simply
              because nobody taught them how to build the business side of their
              trade.
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-ink-700 sm:text-base" data-id="element-121" data-mp="3xlvxkkbh6mo">
              Appliance repair technicians spend years learning how to diagnose
              and repair equipment. But most never receive a practical system
              for:
            </p>
            <ul className="mt-3 grid gap-x-5 gap-y-1.5 sm:grid-cols-2" data-id="element-122" data-mp="5zmlmbhtfzli">
              {creatorGaps.map(gap => <li key={gap} className="flex items-start gap-2 text-sm leading-snug text-ink-800 sm:text-[15px]" data-id="element-123" data-mp="fzvlq0exi566">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-600" aria-hidden="true" data-id="element-124" data-mp="krwtpa52d9qe" />
                  <span data-id="element-125" data-mp="tqikttolpx2s">{gap}</span>
                </li>)}
            </ul>
            <p className="mt-4 font-display text-xl font-extrabold uppercase leading-tight text-ink-900" data-id="element-126" data-mp="yqmtixj9pnig">
              The Premium Technician Kit™ was created to close that gap.
            </p>
            <div className="mt-3 space-y-1 text-[15px] text-ink-700 sm:text-base" data-id="element-127" data-mp="30hzvbdpxvfaa">
              <p data-id="element-128" data-mp="35gt9779518az">It’s not another long business course.</p>
              <p data-id="element-129" data-mp="35hcsaraiy2ql">It’s not a textbook.</p>
              <p data-id="element-130" data-mp="2xxbkzgky7u83">It’s not a collection of random templates.</p>
            </div>
            <p className="mt-3 text-[15px] leading-relaxed text-ink-700 sm:text-base" data-id="element-131" data-mp="2xzekqsbwl1q0">
              It’s a practical toolkit designed to help independent technicians
              install the professional tools and processes their customers can
              actually see.
            </p>
            <p className="mt-3 text-sm font-semibold italic text-ink-600" data-id="element-132" data-mp="2ja8nh9wmllkr">
              Built by Pedro Talavera for technicians who want to turn their
              trade into a more professional business.
            </p>
          </div>
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-133" data-mp="36xgr7neeomko">
          <CTAButton label="Get Pedro’s complete toolkit" sub="$27 USD · Lifetime access" size="md" data-id="element-134" data-mp="36w5gt4qgggkl" />
        </div>
      </div>
    </section>;
}